import StudyDesign from "@components/study-design";
import * as React from 'react';
export default {
  StudyDesign,
  React
};